import {connect} from 'react-redux';

import FeedBuilderTabs from '../components/FeedBuilderTabs';
import {
    getFlatBucketContent,
    getBucketsContent,
} from '../redux/content/selectors';
import {verifyPoorContent} from '../redux/content/actions';
import {fetchEventsForTab} from '../redux/events/actions';
import {getOrganizersUserFollow} from '../redux/organizers/actions';
import {followOrganizer} from '../redux/organizerArticle/actions';

const _mapStateToProps = ({app, content, currencyFormat, user, fiveToFollow}) => ({
    buckets: getBucketsContent(content, currencyFormat, fiveToFollow),
    events: getFlatBucketContent(
        content.flatBucket,
        currencyFormat,
        {shouldShowOnboardingEntryPoint: app.featureFlags.shouldShowOnboardingEntryPoint},
        content.browseState.tabKey,
    ),
    featureFlags: app.featureFlags,
    loadingState: app.loadingState,
    shouldSuggestReloadingPage: !!content.flatBucket.__should_suggest_reloading_page,
    tabKey: content.browseState.tabKey,
    isAuthenticated: user.isAuthenticated,
});

const _mapDispatchToProps = {
    verifyPoorContent,
    fetchEventsForTab,
    getOrganizersUserFollow,
    followOrganizer,
};

export default connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(FeedBuilderTabs);
